import React, { useRef, useEffect, useState } from 'react'
import * as d3 from 'd3'

type GraphUnavailablePropTypes = {
  errorText?: string
}

const GraphUnavailable: React.FC<GraphUnavailablePropTypes> = ({
  errorText = 'Graph not available yet'
}: GraphUnavailablePropTypes) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight
        })
      }
    })

    if (containerRef.current) {
      setDimensions({
        width: containerRef.current.offsetWidth,
        height: containerRef.current.offsetHeight
      })
    }

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  useEffect(() => {
    const svg = d3.select(svgRef.current)
    const { width, height } = dimensions

    if (width === 0 || height === 0) return

    const numLines = 5
    const middleLineIndex = Math.floor(numLines / 2)

    const yScale = d3
      .scaleLinear()
      .domain([0, numLines - 1])
      .range([0, height])

    svg.selectAll('*').remove()

    svg
      .append('g')
      .selectAll('line')
      .data(d3.range(numLines))
      .enter()
      .append('line')
      .attr('x1', 0)
      .attr('y1', (d) => yScale(d))
      .attr('x2', width)
      .attr('y2', (d) => yScale(d))
      .attr('stroke', '#D1D6D6')
      .attr('stroke-width', 1)

    const middleLineY = yScale(middleLineIndex)

    const text = svg
      .append('text')
      .attr('x', width / 2)
      .attr('y', middleLineY)
      .attr('text-anchor', 'middle')
      .attr('dy', '.35em')
      .style('font-size', '13px')
      .style('fill', '#8E9393')
      .text(errorText ?? 'Graph unavailable')

    const bbox = text.node()?.getBBox()
    if (bbox) {
      svg
        .insert('rect', 'text') // Insert rect before text
        .attr('x', bbox.x - 10)
        .attr('y', bbox.y - 10)
        .attr('width', bbox.width + 20)
        .attr('height', bbox.height + 20)
        .attr('rx', 12)
        .attr('ry', 12)
        .attr('fill', 'white')
        .attr('stroke', '#D1D6D6')
        .attr('stroke-width', 1)
    }
  }, [dimensions])

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      <svg
        ref={svgRef}
        width='100%'
        height={dimensions.height}
        viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
        preserveAspectRatio='none'
        overflow='hidden'
      ></svg>
    </div>
  )
}

export default GraphUnavailable
